import React from 'react';
import ReactDOM from 'react-dom';
const BreadcrumbsPortal = _ref => {
  let {
    children
  } = _ref;
  const navbar = document.getElementById('navbar-breadcrumbs');
  const portal = navbar ? /*#__PURE__*/ReactDOM.createPortal(children, navbar) : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, portal);
};
export default BreadcrumbsPortal;